import { render, staticRenderFns } from "./FlatToggle.vue?vue&type=template&id=a94d6872"
import script from "./FlatToggle.vue?vue&type=script&lang=js"
export * from "./FlatToggle.vue?vue&type=script&lang=js"
import style0 from "./FlatToggle.vue?vue&type=style&index=0&id=a94d6872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports